import Main from './modules/Main.js'
import Utils from './modules/Utils.js'
import 'container-query-polyfill'

const modules = {
  ReactFactory: async () =>
    import(
      /* webpackChunkName: 'ReactFactory' */ `./factories/ReactFactory.js`
    ),
  QuickSearch: async () =>
    import(/* webpackChunkName: 'QuickSearch' */ `./modules/QuickSearch.js`),
  UniversalSearchTypeaheadFactory: async () =>
    import(
      /* webpackChunkName: 'UniversalSearchTypeaheadFactory' */ `./factories/UniversalSearchTypeaheadFactory.js`
    ),
}

const mainInstance = new Main(modules, Utils)
mainInstance.init()
